import React, { useEffect, useState, useCallback } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import {FaEdit, FaCircle } from "react-icons/fa"; // Import icons
import ViewBrand from "./viewBrand/viewBrand"; // Import ViewBrand modal
import EditBrand from "./editBrand/editBrand"; // Import ViewBrand modal
import AddBrand from "./addBrand/AddBrand";
import { api } from '../../api';
import { toast } from "react-toastify";
import { customStyles } from "../../styles/dataTableStyles";
import Swal from "sweetalert2";

const Brand = () => {
  // eslint-disable-next-line
  const navigate = useNavigate();
  // eslint-disable-next-line
  const { userType: role } = useSelector((state) => state.auth.user);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const token = useSelector((state) => state.auth.token);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [pageSize, setPageSize] = useState(10); // Default page size


  const [showAddBrandModal, setShowAddBrandModal] = useState(false);
  const [showEditBrandModal, setShowEditBrandModal] = useState(false);
  const [showViewBrandModal, setShowViewBrandModal] = useState(false);
  const [listingReset, setListingReset] = useState(false);

  const fetchBrands = useCallback(async (pageNo, searchKey, pageSize) => {
    try {
      setLoading(true);
      const response = await api.brands.getBrandsList(
        { pageNo, pageSize, sort: "desc", sortBy: "createdAt", searchKey },
        token
      );
      
      if (response.success) {
        setBrands(response.data.result);
        setTotalRows(response.data.totalCount);
      }
    } catch (error) {
      setBrands([]);
      setTotalRows(0);
      console.error("Error fetching brands", error);
    } finally {
      setLoading(false);
    }
  }, [token]);

    useEffect(() => {
  
        setPage(1);
      // eslint-disable-next-line
    }, [search]);

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      // setPage(1); 
      fetchBrands(page, search, pageSize);
    }, 500); // Debounce API call to reduce requests

    return () => clearTimeout(delaySearch);
  }, [page, search,listingReset, pageSize, fetchBrands]);




  const fetchBrandDetails = async (brandId, action) => {
    try {
      const response = await api.brands.getBrandById({ brandId },token);
  
      if (response.success) {
        setSelectedBrand(response.data);
  
        if (action === "view") {
          setShowViewBrandModal(true);
        } else if (action === "edit") {
          setShowEditBrandModal(true);
        }
      } else {
        
      }
    } catch (error) {
      
    }
  };

    // Define action handlers
    const handleView = (row) => {
      fetchBrandDetails(row.brandId, "view");
    };
  
    const handleEdit = (row) => {
      fetchBrandDetails(row.brandId, "edit");
    };
  
    const handleDelete = async (row) => {

      Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to inactive this brand?",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "rgb(112 110 115)",
        confirmButtonText: "Okay",
      }).then(async (result) => {
        if (result.isConfirmed) {
      try {
        const response = await api.brands.delete({ delete_array: [row.brandId] }, token);
    
        if (response.success) {
          toast.success("Brand deactivate successfully!");
          setListingReset(prev => !prev); // Force re-fetching brands
        } else {
          toast.error("Unable to deactivate brand!");
        }
      } catch (error) {
     
        
      }

        }
      });
    };

    
    const handleActivate = async (row) => {

      Swal.fire({
        title: "Are you sure?",
        text: "Do you really want to activate this brand?",
        showCancelButton: true,
        confirmButtonColor: "rgb(68, 170, 68)",
        cancelButtonColor: "rgb(112 110 115)",
        confirmButtonText: "Activate",
      }).then(async (result) => {
        if (result.isConfirmed) {
      try {
        const response = await api.brands.delete({ delete_array: [row.brandId],"status":true }, token);
    
        if (response.success) {
          toast.success("Brand enabled successfully!");
          setListingReset(prev => !prev); // Force re-fetching brands
        } else {
          toast.error("Unable to enable brand!");
        }
      } catch (error) {
     
        
      }

        }
      });
    };


    

    
    const closeModal = () => {
      setShowAddBrandModal(false);
      setShowEditBrandModal(false);
      setShowViewBrandModal(false);
    }
  

  const columns = [
    { name: "ID", selector: row => row.brandId, sortable: true, width: "70px", wrap: true },
    { name: "Brand Name", selector: row => row.brandName, sortable: true , width: "200px", wrap: true },
    { name: "Company Name", selector: row => row.brandCompanyName, sortable: true , width: "250px", wrap: true },
    { name: "Website", selector: row => row.brandWebsite, cell: row => <a href={row.brandWebsite} target="_blank" rel="noopener noreferrer">{row.brandWebsite}</a>, width: "180px", wrap: true   },
    { name: "API", selector: row => (row.brandApiAccess ? "Yes" : "No"), sortable: true,width: "100px", wrap: true   },
    { name: "Status", selector: row => (row.brandStatus ? "Active" : "Inactive"), sortable: true , 
      width: "150px", 
      wrap: true, 
      cell: row => (
        <span 
          style={{
            padding: "5px 10px",
            borderRadius: "5px",
            // color: "#fff",
            color: row.brandStatus ? "#44aa44" : "#ff4b4b",
            // backgroundColor: row.brandStatus ? "#44aa44" : "#ff4b4b"
          }}
        >
          {row.brandStatus ? "Active" : "Inactive"}
        </span>
      )},
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
        {row.brandStatus ? (
          <>
            <button className="btn btn-primary btn-sm" style={{ width: "70px" }} onClick={() => handleView(row)}>
              View
            </button>
            <button className="listButton" onClick={() => handleEdit(row)}>
              <FaEdit />
            </button>
            <button title="Click to Inactive" className="listButton" onClick={() => handleDelete(row)}>
            <FaCircle style={{ fill: 'green' }} />
            </button>
          </>
        ) : (
          <button title="Click to Active" className="listButton" style={{ width: "80px" }} onClick={() => handleActivate(row)}>
            <FaCircle style={{ fill: 'grey' }}/>
          </button>
        )}
      </div>
      ),
      ignoreRowClick: true,
     
    
      width: "200px",
      wrap: true
    }

  ];


  return (
    <div className="container-fluid mt-4">
      {/* <div className="d-flex justify-content-end mb-3">
      <button className="btn new-btn-top btn-primary">
        ADD BRAND
      </button>
    </div> */}

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="sec-header">BRANDS</h2>
        <div className="d-flex align-items-center">
          <label className="mr-2">Search:</label>
          <input
            type="text"
            placeholder="Company Name"
            className="form-control"
            style={{ width: "200px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

    <button className="btn new-btn-top btn-primary" style={{ marginLeft: "10px", marginTop: "15px" }} onClick={() => setShowAddBrandModal(true)} >
      ADD BRAND
    </button>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={brands}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        onChangePage={setPage}
        onChangeRowsPerPage={(newPageSize, newPage) => {
          setPageSize(newPageSize);
          setPage(newPage); // Reset to selected page
        }}
        highlightOnHover
        customStyles={customStyles} // Apply custom styles
        responsive // ✅ Enable responsive mode
        noHeader={false}
        noTableHead={false}
        wrap // ✅ Prevents horizontal scroll
      />

        {/* View Brand Modal */}
        {showViewBrandModal && selectedBrand && (
        <ViewBrand
          showViewBrandModal={showViewBrandModal}
          brand={selectedBrand}
          closeModal={closeModal}
          setShowEditBrandModal={setShowEditBrandModal}
          setShowViewBrandModal={setShowViewBrandModal}
        />
      )}

      {showEditBrandModal && (
        <EditBrand
          showEditBrandModal={showEditBrandModal}
          setListingReset = {setListingReset}
          brand={selectedBrand}
          token={token}
          setShowEditBrandModal={setShowEditBrandModal}
          closeModal={closeModal}
        />
      )}

      {showAddBrandModal && (
        <AddBrand
          showAddBrandModal={showAddBrandModal}
          setShowAddBrandModal={setShowAddBrandModal}
          setUpdateData={setListingReset} // Force refresh after adding
          closeModal={closeModal}
          token={token}
          setListingReset = {setListingReset}
        />
      )}
    </div>
  );
};

export default Brand;
